// extracted by mini-css-extract-plugin
export default {"wrapper":"j3zx4lySHG429qTcbyY_","icon":"XKAFCuYDgDgLwpoMkCmk"};